module.exports = "/images/cooper-1.jpg";